<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Podgorica and its surroundings</h1>
    <!-- <div class='tourPic'>
      <img src='@/assets/placestogo/03/01.jpg'>
    </div> -->
    <div
      style='
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 10px 5vw;
      '
    >
      <vue-picture-swipe :items='items'></vue-picture-swipe>
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <!-- <span class='fa-li'><img  src='@/assets/logo/lovcen-green.png'/></span>
      <a data-toggle='collapse' href='#tourDescription'><h4 class='titles'>Tour description</h4></a> -->
          <div class='' id=''>
            <p class='pasus'>
              The capital city of Montenegro – Podgorica is located in the
              central region of the country. With population just around 200.000
              it is considered one of the smallest capitals in Europe.
            </p>
            <p class='pasus'>
              The official name Podgorica appears for the first time in the 14th
              century although it is certain that the very area was inhabited
              centuries before. And only a few kilometers from the city center
              there are remains of Roman town Doclea dating back from the first
              decade of the 1st century A.D. which at some point of time was the
              seat of Roman province Praevalitana.
            </p>
            <p class='pasus'>
              For centuries before Christ the area of today’s Podgorica had been
              inhabited by Illyrian tribes whose traces can still be seen on
              nearby hills.
            </p>
            <p class='pasus'>
              Podgorica suffered from major destructions from bombing during
              WWII whereby the most of buildings was either razed to the ground
              or substantially damaged. Today there are a few buildings from the
              period before the war that survived the devastation.
            </p>
            <p class='pasus'>
              This is the city of sun and rivers, one of the warmest in Europe.
              5 clear and cold rivers flow through or nearby city center and not
              far from the city they represent a true fortune and a refreshment
              solution for local residents in hot summer days. Winters are mild
              and although snow can be quite big in the mountainous area nearby,
              it is quite rare in Podgorica.
            </p>
            <p class='pasus'>
              Particularly interesting for nature and mountain lovers is a
              nearby Zijovo massif with peaks over 2000 meters high, spectacular
              viewpoints and glacial lakes.
            </p>
            <p class='pasus'>
              The extraordinary position of the city – close to the largest lake
              in the Balkans, Skadar Lake and the national park of the same name
              (20km), in the proximity of both Adriatic Sea (50km) and the
              mountain area, provides a number of possibilities for local
              residents and tourists who choose Podgorica for their base to
              reach sites od extraordinary natural beauties in relatively short
              time.
            </p>
            <p class='pasus'>
              Podgorica has a rich cultural heritage too. Beside archeological
              site Doclea which is the most important locality from Roman
              period, there are remains of Illyrian town Meteon from 3rd century
              B.C, one of the largest and the most beautiful temples in the
              world, an old town dating back from Ottoman period with its
              authentic architecture and many bridges from different historical
              periods.
            </p>
            <p class='pasus'>
              Podgorica is where different religious and national communities
              harmoniously coexist, cherishing and speaking proudly about
              multiculturalism.
            </p>
            <p class='pasus'>
              The city is known for its culture of coffee drinking, causal
              attitude of their citizens and sports’ successes of local teams
              and individual sports players.
            </p>
            <p class='pasus'>
              Finally, Podgorica is the city of great wines, brandy, grape,
              watermelon, fig and pomegranate, tall and beautiful people and
              amusing nightlife.
            </p>
            <p class='pasus'>Welcome!</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/placestogo/03/01.jpg'),
          thumbnail: require('@/assets/placestogo/03/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/03/02.jpg'),
          thumbnail: require('@/assets/placestogo/03/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/03/03.jpg'),
          thumbnail: require('@/assets/placestogo/03/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/03/04.jpg'),
          thumbnail: require('@/assets/placestogo/03/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/03/05.jpg'),
          thumbnail: require('@/assets/placestogo/03/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/03/06.jpg'),
          thumbnail: require('@/assets/placestogo/03/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/03/07.jpg'),
          thumbnail: require('@/assets/placestogo/03/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/03/08.jpg'),
          thumbnail: require('@/assets/placestogo/03/08.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/03/09.jpg'),
          thumbnail: require('@/assets/placestogo/03/09.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/03/10.jpg'),
          thumbnail: require('@/assets/placestogo/03/10.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/03/11.jpg'),
          thumbnail: require('@/assets/placestogo/03/11.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/PTG3_Podgorica.vue